import React, { useState } from "react";
import "./ProductsSection.css";
import { useTranslation } from "react-i18next";
import { getProducts } from "./api";
import { useQuery } from "@tanstack/react-query";
import fallbackImg from "../../../../../assets/images/fallback.png";

function ProductsSection() {
  const { t, i18n } = useTranslation("home");

  const { data, isLoading } = useQuery({
    queryKey: ["references"],
    queryFn: getProducts,
  });
  console.log(i18n.language.toLocaleLowerCase());
  if (isLoading) return <p>Loading...</p>;

  return (
    <section className="products-page-section">
      <div className="container products-section-container">
        {data?.map((item) => (
          <div className="products-card">
            <picture>
              <img src={item.image_url || fallbackImg} alt="" />
            </picture>
            <div className="products-card-content">
              <h6>{item.name?.[i18n.language.toLocaleLowerCase()]}</h6>
              <p className="small">
                {item.description?.[i18n.language.toLocaleLowerCase()]}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ProductsSection;
